import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useParams } from "react-router-dom";
import { ConfigProvider } from "./context/ConfigContext";
import { WatchModalProvider } from "./context/WatchModalContext";
import { TrailerModalProvider } from "./context/TrailerModalContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { AdSlot } from "./components/AdSlot";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import MovieDetail from "./pages/MovieDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!document.querySelector('[role="dialog"]')) document.body.style.pointerEvents = "";
  }, [pathname]);
  return null;
};

const DetailRoute = ({ media }) => {
  const { id } = useParams();
  return <MovieDetail key={`${media}-${id}`} media={media} />;
};

const Page = ({ children }) => {
  const { pathname } = useLocation();
  return <AppErrorBoundary key={pathname}>{children}</AppErrorBoundary>;
};

function App() {
  return (
    <ConfigProvider>
      <BrowserRouter>
      <WatchModalProvider>
      <TrailerModalProvider>
        <ScrollTop />
        <div className="flex min-h-screen flex-col bg-[#0a0a0a] text-neutral-100">
          <Navbar />
          <main className="flex-1">
            <Page>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/movies" element={<Catalog key="movie" media="movie" />} />
              <Route path="/tv" element={<Catalog key="tv" media="tv" />} />
              <Route path="/movie/:id" element={<DetailRoute media="movie" />} />
              <Route path="/tv/:id" element={<DetailRoute media="tv" />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Routes>
            </Page>
          </main>
          <AdSlot name="footer" size="slim" className="mt-10" />
          <Footer />
        </div>
      </TrailerModalProvider>
      </WatchModalProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
